module.exports = __webpack_public_path__ + "img/zh.af89e497.png";